import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { generalService } from '../../services/general.service';
import { MetodoPago } from '../../models/metodo-pago';
import { Usuario } from '../../models/usuario';
import { MontoCajaCorte } from '../../models/monto-caja-corte';
import { MontoRetiro } from '../../models/monto-retiro';
import { validarNumeroPositivo } from '../../utils/validators/validators';
import { DocumentType } from '../../models/document_type';
import { FondoCorteCaja } from '../../models/fondo-corte-caja';
import { DatosGeneralesSAE } from '../../datos-generales-SAE';
import { CorteCajaWrapper } from '../../models/corte-caja-wrapper';
import { DocumentoDetalle } from '../../models/DocumentoDetalle';
import { Documento } from '../../models/documento';
import * as moment from 'moment';
import { Router, ActivatedRoute } from '@angular/router';
import { HistorialCorte } from '../../models/historial-corte';
import { forkJoin } from 'rxjs/observable/forkJoin';
import * as jsPDF from 'jspdf';
import * as html2canvas from 'html2canvas';

@Component({
  selector: 'app-realizar-corte-caja',
  templateUrl: './realizar-corte-caja.component.html',
  styleUrls: ['./realizar-corte-caja.component.scss'],
  providers: [generalService]
})
export class RealizarCorteCajaComponent implements OnInit {

  @Input()
  public idHistorialCorte: number = null;
  private historicoConsultado = false;

  private formaPagoService = 'formaPago/';
  private corteCajaService = 'corteCaja/';
  public fechaMaxima = new Date();
  public fechaMinima = new Date();
  private fondoCaja = 0;
  public corteGuardado = false;
  public datosGeneralesSAE: any;

  public tiposCorte: DocumentType[] = [];
  public metodosPago: MetodoPago[] = [];
  public listaDenominaciones: { nombre: string, identificador: number }[] = [
    { nombre: '$500.00', identificador: 500 },
    { nombre: '$200.00', identificador: 200 },
    { nombre: '$100.00', identificador: 100 },
    { nombre: '$50.00', identificador: 50 },
    { nombre: '$20.00', identificador: 20 },
    { nombre: '$10.00', identificador: 10 },
    { nombre: '$5.00', identificador: 5 },
    { nombre: '$2.00', identificador: 2 },
    { nombre: '$1.00', identificador: 1 }
  ];
  public listaAcciones: { nombre: string, identificador: number }[] = [
    { nombre: 'Condonar', identificador: 1 },
    { nombre: 'Pagar diferencia', identificador: 2 }
  ];

  public formularioCorteCaja: FormGroup;

  constructor(private _generalService: generalService,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute) {
    this.construirFormulario();
    this.fechaMinima.setDate(this.fechaMinima.getDate() - 1);
    this.datosGeneralesSAE = DatosGeneralesSAE;
  }

  ngOnInit() {
    this.suscribirCambiosIngresos();
    this.suscribirCambiosDetalleCorte();

    this.cargarSecciones();
  }

  cargarSecciones() {
    const primeraSeccion = this.cargarPrimeraSeccion();
    const terceraSeccion = this.cargarTerceraSeccion();

    this.datosGeneralesSAE.showSpinnerLoading = true;
    forkJoin(primeraSeccion, terceraSeccion)
      .subscribe(() => {
        this.datosGeneralesSAE.showSpinnerLoading = false;
      });
  }

  consultarDetalleHistorico() {
    if (!this.historicoConsultado) {
      this.historicoConsultado = true;
      this._generalService.metodoCall(this.corteCajaService + `/consultarCorte?idHistorialCorte=${this.idHistorialCorte}`, true)
        .subscribe((corte: HistorialCorte[]) => {
          if (corte.length > 0) {
            //this.deshabilitarControles();
            this.llenarFormulario(corte[0]);
          }
          this.datosGeneralesSAE.showSpinnerLoading = false;
        }, (error) => {
          this.datosGeneralesSAE.showSpinnerLoading = false;
        });
    }
  }

  construirFormulario() {
    this.formularioCorteCaja = this.formBuilder.group({
      montoRetiro: this.formBuilder.control({ value: 0.00, disabled: true }, [Validators.required]),
      cantidadDenominacion500: this.formBuilder.control(0, [Validators.required, validarNumeroPositivo]),
      cantidadDenominacion200: this.formBuilder.control(0, [Validators.required, validarNumeroPositivo]),
      cantidadDenominacion100: this.formBuilder.control(0, [Validators.required, validarNumeroPositivo]),
      cantidadDenominacion50: this.formBuilder.control(0, [Validators.required, validarNumeroPositivo]),
      cantidadDenominacion20: this.formBuilder.control(0, [Validators.required, validarNumeroPositivo]),
      cantidadDenominacion10: this.formBuilder.control(0, [Validators.required, validarNumeroPositivo]),
      cantidadDenominacion5: this.formBuilder.control(0, [Validators.required, validarNumeroPositivo]),
      cantidadDenominacion2: this.formBuilder.control(0, [Validators.required, validarNumeroPositivo]),
      cantidadDenominacion1: this.formBuilder.control(0, [Validators.required, validarNumeroPositivo]),
      totalEfectivo: this.formBuilder.control({ value: 0.00, disabled: true }, [Validators.required]),
      totalVoucher: this.formBuilder.control(0.00, [Validators.required]),
      totalIngresos: this.formBuilder.control({ value: 0.00, disabled: true }, [Validators.required]),
      fechaCorte: this.formBuilder.control(moment(this.fechaMaxima).toISOString(true), [Validators.required]),
      tipoCorte: this.formBuilder.control(null, [Validators.required]),
      fondoCaja: this.formBuilder.control(null, [Validators.required]),
      diferencia: this.formBuilder.control({ value: 0.00, disabled: true }, [Validators.required]),
      accion: this.formBuilder.control({ value: null, disabled: true }, [Validators.required]),
      faltante: this.formBuilder.control({ value: 0.00, disabled: true }, []),
      usuario: this.formBuilder.control(null, [Validators.required]),
      contrasena: this.formBuilder.control(null, [Validators.required])
    });
  }

  llenarFormulario(corte: HistorialCorte) {

    this.metodosPago.forEach((metodoPago) => {
      this.formularioCorteCaja.get(metodoPago.NAME).setValue(corte[`monto${metodoPago.WAY_TO_PAY_ID}`]);
    });

    this.formularioCorteCaja.get('montoRetiro').setValue(corte.retiro);
    this.formularioCorteCaja.get('cantidadDenominacion500').setValue(corte.cantidadDenominacion500);
    this.formularioCorteCaja.get('cantidadDenominacion200').setValue(corte.cantidadDenominacion200);
    this.formularioCorteCaja.get('cantidadDenominacion100').setValue(corte.cantidadDenominacion100);
    this.formularioCorteCaja.get('cantidadDenominacion50').setValue(corte.cantidadDenominacion50);
    this.formularioCorteCaja.get('cantidadDenominacion20').setValue(corte.cantidadDenominacion20);
    this.formularioCorteCaja.get('cantidadDenominacion10').setValue(corte.cantidadDenominacion10);
    this.formularioCorteCaja.get('cantidadDenominacion5').setValue(corte.cantidadDenominacion5);
    this.formularioCorteCaja.get('cantidadDenominacion2').setValue(corte.cantidadDenominacion2);
    this.formularioCorteCaja.get('cantidadDenominacion1').setValue(corte.cantidadDenominacion1);
    this.formularioCorteCaja.get('totalEfectivo').setValue(corte.ingresoEfectivo);
    this.formularioCorteCaja.get('totalVoucher').setValue(corte.ingresoVoucher);
    this.formularioCorteCaja.get('totalIngresos').setValue(corte.totalIngresos);
    this.formularioCorteCaja.get('fechaCorte').setValue(new Date(corte.fechaCorte));
    this.formularioCorteCaja.get('tipoCorte').setValue(corte.idTipoCorte);

    this.formularioCorteCaja.get('fondoCaja').setValue(corte.fondoCaja);
    this.fondoCaja = corte.fondoCaja;

    this.formularioCorteCaja.get('diferencia').setValue(corte.diferencia);
    this.formularioCorteCaja.get('accion').setValue(corte.accionDiferencia);
    this.formularioCorteCaja.get('faltante').setValue(corte.faltante);
    this.formularioCorteCaja.get('usuario').setValue(null);
    this.formularioCorteCaja.get('contrasena').setValue(null);
  }

  suscribirCambiosIngresos() {
    this.subscribeCambiosDenominacioens();
    this.subscribeCambiosTotalVoucher();
  }

  suscribirCambiosDetalleCorte() {
    const controles = ['totalIngresos', 'fondoCaja'];

    for (let index = 0; index < controles.length; index++) {
      const control = controles[index];

      this.formularioCorteCaja.get(control).valueChanges
        .subscribe((valor) => {
          if (valor >= 0) {
            const sumatoriaMontosMetodosPago = this.obtenerSumatoriaMontosMetodosPago();
            const montoRetiros = this.formularioCorteCaja.get('montoRetiro').value;
            const montoTotalIngresos = this.formularioCorteCaja.get('totalIngresos').value;
            const montoFondoCaja = this.formularioCorteCaja.get('fondoCaja').value;

            const diferencia = sumatoriaMontosMetodosPago - montoRetiros - (montoTotalIngresos - montoFondoCaja);
            if (diferencia > 0) {
              this.formularioCorteCaja.get('accion').enable();
            } else {
              this.formularioCorteCaja.get('accion').disable();
              this.formularioCorteCaja.get('accion').setValue(null);
            }
            this.formularioCorteCaja.get('faltante').setValue(Math.abs(diferencia).toFixed(2));
            this.formularioCorteCaja.get('diferencia').setValue(Math.abs(diferencia).toFixed(2));
          }
        });
    }
  }

  obtenerSumatoriaMontosMetodosPago(): number {
    let sumatoria = 0;
    this.metodosPago.forEach((metodoPago) => {
      sumatoria += this.formularioCorteCaja.get(metodoPago.NAME).value;
    });

    return sumatoria;
  }

  subscribeCambiosDenominacioens() {
    const controlesDenominacionesAEscuchar = [{ nombre: 'cantidadDenominacion500', multiplicador: 500 },
    { nombre: 'cantidadDenominacion200', multiplicador: 200 },
    { nombre: 'cantidadDenominacion100', multiplicador: 100 },
    { nombre: 'cantidadDenominacion50', multiplicador: 50 },
    { nombre: 'cantidadDenominacion20', multiplicador: 20 },
    { nombre: 'cantidadDenominacion10', multiplicador: 10 },
    { nombre: 'cantidadDenominacion5', multiplicador: 5 },
    { nombre: 'cantidadDenominacion2', multiplicador: 2 },
    { nombre: 'cantidadDenominacion1', multiplicador: 1 }];

    for (let index = 0; index < controlesDenominacionesAEscuchar.length; index++) {
      const controlDenominacion = controlesDenominacionesAEscuchar[index];

      this.formularioCorteCaja.get(controlDenominacion.nombre)
        .valueChanges.subscribe((cantidad) => {
          if (cantidad && cantidad >= 0) {
            this.establecerTotalIngresos();
          }
        });
    }
  }

  subscribeCambiosTotalVoucher() {
    this.formularioCorteCaja.get('totalVoucher')
      .valueChanges.subscribe((cantidad) => {
        if (cantidad && cantidad > 0) {
          this.establecerTotalIngresos();
        }
      });
  }

  establecerTotalEfectivo(controlesDenominacionesAEscuchar) {
    let totalEfectivo = 0;
    for (let index = 0; index < controlesDenominacionesAEscuchar.length; index++) {
      const controlDenominacion = controlesDenominacionesAEscuchar[index];
      totalEfectivo += this.formularioCorteCaja.get(controlDenominacion.nombre).value * controlDenominacion.multiplicador;
    }
    this.formularioCorteCaja.get('totalEfectivo').setValue(totalEfectivo);
  }

  establecerTotalIngresos() {
    const controlesDenominaciones = [
      { nombre: 'cantidadDenominacion500', multiplicador: 500 },
      { nombre: 'cantidadDenominacion200', multiplicador: 200 },
      { nombre: 'cantidadDenominacion100', multiplicador: 100 },
      { nombre: 'cantidadDenominacion50', multiplicador: 50 },
      { nombre: 'cantidadDenominacion20', multiplicador: 20 },
      { nombre: 'cantidadDenominacion10', multiplicador: 10 },
      { nombre: 'cantidadDenominacion5', multiplicador: 5 },
      { nombre: 'cantidadDenominacion2', multiplicador: 2 },
      { nombre: 'cantidadDenominacion1', multiplicador: 1 }];

    this.establecerTotalEfectivo(controlesDenominaciones);

    const totalIngresos = parseFloat(this.formularioCorteCaja.get('totalVoucher').value) + this.formularioCorteCaja.get('totalEfectivo').value;
    this.formularioCorteCaja.get('totalIngresos').setValue(totalIngresos.toFixed(2));
  }

  consultarFormasPago(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.datosGeneralesSAE.showSpinnerLoading = true;
      this._generalService.metodoCall(this.formaPagoService + `consultarMetodosPago?idCliente=${-1}&esPantallaPagos=${0}`)
        .subscribe((metodosPago) => {
          this.metodosPago = metodosPago;
          this.agregarCamposMontoMetodoPago();
          resolve()
        }, (error) => {
          console.log(error);
          reject();
        });
    });
  }

  agregarCamposMontoMetodoPago() {
    this.metodosPago.forEach((metodoPago) => {
      this.formularioCorteCaja.addControl(metodoPago.NAME, this.formBuilder.control({ value: 0, disabled: true }, [Validators.required]));
    });
  }

  procesarFormulario() {
    this.marcarCamposRequeridos();
    const usuarioValido = this.validarUsuario();
    if (!usuarioValido) {
      this._generalService.toastCall('El Usuario deber ser igual al del Usuario en sesión');
      return;
    }

    if (this.formularioCorteCaja.valid) {
      this.guardarCorteCaja();
    }
  }

  validarUsuario() {
    const usuario = this.formularioCorteCaja.get('usuario').value;
    const usuarioSession: Usuario = JSON.parse(sessionStorage.getItem('user'));
    return usuario === usuarioSession.EMAIL;
  }

  guardarCorteCaja() {
    const corteCajaWrapper = this.generarCorteCajaWrapper();

    if (this.idHistorialCorte) {
      this.actualizarCorteCaja(corteCajaWrapper)
    } else {
      this.agregarCorteCaja(corteCajaWrapper)
    }
  }

  agregarCorteCaja(corteCajaWrapper) {
    this._generalService.metodoCallParams(corteCajaWrapper, this.corteCajaService + 'guardarCorte', true)
      .subscribe((documents: Documento[]) => {
        const document = documents[0];
        this.corteGuardado = true;
        this._generalService.toastCall(`Corte Núm. ${document.DOCUMENT_NUMBER} generado exitosamente`);
        this.deshabilitarControles();
      }, (error) => {
      });
  }

  actualizarCorteCaja(corteCajaWrapper) {
    console.log('actuaizando...');

    console.log(corteCajaWrapper);

    this._generalService.metodoCallParams(corteCajaWrapper, this.corteCajaService + 'actualizarCorte', true)
      .subscribe((documents: Documento[]) => {
        const document = documents[0];
        this.corteGuardado = true;
        this._generalService.toastCall(`Corte Núm. ${document.DOCUMENT_NUMBER} actualizado exitosamente`);
        this.deshabilitarControles();
      }, (error) => {
      });
  }

  deshabilitarControles() {
    Object.keys(this.formularioCorteCaja.controls).forEach(key => {
      this.formularioCorteCaja.get(key).disable();
    });
  }

  limpiarFormulario() {
    this.corteGuardado = false;
    this.idHistorialCorte = null;

    Object.keys(this.formularioCorteCaja.controls).forEach(key => {
      this.formularioCorteCaja.get(key).enable();
      this.formularioCorteCaja.get(key).setValue(0.0);
    });
    this.formularioCorteCaja.get('fechaCorte').setValue(this.fechaMaxima);
    this.formularioCorteCaja.get('usuario').setValue(null);
    this.formularioCorteCaja.get('usuario').reset();
    this.formularioCorteCaja.get('contrasena').setValue(null);
    this.formularioCorteCaja.get('contrasena').reset();
    this.formularioCorteCaja.get('accion').reset();
    this.formularioCorteCaja.get('diferencia').disable();

    this.cargarSecciones();
  }

  generarCorteCajaWrapper() {
    const corteCajaWrapper = new CorteCajaWrapper();
    corteCajaWrapper.detalleMetodosPago = this.generarDetalleMetodosPago();
    corteCajaWrapper.detalleRetiros = this.generarDetalleRetiros();
    corteCajaWrapper.detalleTotalMetodosPago = this.generarDetalleTotalMetodosPago();
    corteCajaWrapper.detalleDenominaciones = this.generarDetalleDenominaciones();
    corteCajaWrapper.detalleEfectivo = this.generarDetalleEfectivo();
    corteCajaWrapper.detalleVoucher = this.generarDetalleVoucher();
    corteCajaWrapper.detalleIngresos = this.generarDetalleIngresos();
    corteCajaWrapper.detalleFondoCaja = this.generarDetalleFondoCaja();
    corteCajaWrapper.detalleDiferencia = this.generarDetalleDiferencia();
    corteCajaWrapper.corteDetalle = this.generarCorteDetalle();
    corteCajaWrapper.usuario = this.formularioCorteCaja.get('usuario').value;
    corteCajaWrapper.contrasena = this.formularioCorteCaja.get('contrasena').value;

    corteCajaWrapper.documentId = this.idHistorialCorte;
    return corteCajaWrapper;
  }

  generarDetalleMetodosPago(): DocumentoDetalle[] {
    const detalles: DocumentoDetalle[] = [];
    this.metodosPago.forEach((metodoPago) => {
      const detalle = new DocumentoDetalle();
      const monto = parseFloat(this.formularioCorteCaja.get(metodoPago.NAME).value);

      detalle.DOCUMENT_DETAIL_TYPE = null; // Buscar el Id del registro 'Corte - Método Pago'
      detalle.QUANTITY = monto;
      detalle.TOTAL = monto;
      detalle.COMMENTS = metodoPago.NAME;

      detalles.push(detalle);
    });
    return detalles;
  }

  generarDetalleRetiros(): DocumentoDetalle {
    const detalle = new DocumentoDetalle();
    const monto = parseFloat(this.formularioCorteCaja.get('montoRetiro').value);

    detalle.DOCUMENT_DETAIL_TYPE = null; // Buscar el Id del registro 'Corte - Retiro'
    detalle.QUANTITY = monto;
    detalle.TOTAL = monto;
    detalle.COMMENTS = 'Retiro';
    return detalle;
  }

  generarDetalleTotalMetodosPago(): DocumentoDetalle {
    const detalle = new DocumentoDetalle();
    const montoRetiro = parseFloat(this.formularioCorteCaja.get('montoRetiro').value);
    let sumatoriaMontosMetodosPago = 0;

    this.metodosPago.forEach((metodoPago) => {
      const monto = parseFloat(this.formularioCorteCaja.get(metodoPago.NAME).value);
      sumatoriaMontosMetodosPago += monto;
    });

    detalle.DOCUMENT_DETAIL_TYPE = null; // Buscar el Id del registro 'Corte - Pagos y Retiros'
    detalle.QUANTITY = sumatoriaMontosMetodosPago - montoRetiro;
    detalle.TOTAL = detalle.QUANTITY;
    detalle.COMMENTS = 'Total Pagos y Retiros';
    return detalle;
  }

  generarDetalleDenominaciones(): DocumentoDetalle[] {
    const detalles: DocumentoDetalle[] = [];

    const controlesDenominaciones = [{ nombre: 'cantidadDenominacion500', multiplicador: 500 },
    { nombre: 'cantidadDenominacion200', multiplicador: 200 },
    { nombre: 'cantidadDenominacion100', multiplicador: 100 },
    { nombre: 'cantidadDenominacion50', multiplicador: 50 },
    { nombre: 'cantidadDenominacion20', multiplicador: 20 },
    { nombre: 'cantidadDenominacion10', multiplicador: 10 },
    { nombre: 'cantidadDenominacion5', multiplicador: 5 },
    { nombre: 'cantidadDenominacion2', multiplicador: 2 },
    { nombre: 'cantidadDenominacion1', multiplicador: 1 }];

    for (let index = 0; index < controlesDenominaciones.length; index++) {
      const controlDenominacion = controlesDenominaciones[index];
      const cantidadDenominacion = this.formularioCorteCaja.get(controlDenominacion.nombre).value;
      const montoDenominacion = cantidadDenominacion * controlDenominacion.multiplicador;

      const detalle = new DocumentoDetalle();

      detalle.DOCUMENT_DETAIL_TYPE = null; // Buscar el Id del registro 'Corte - Denominación'
      detalle.QUANTITY = cantidadDenominacion;
      detalle.TOTAL = montoDenominacion;
      detalle.COMMENTS = `${controlDenominacion.multiplicador}.00`;

      detalles.push(detalle);
    }

    return detalles;
  }

  generarDetalleEfectivo(): DocumentoDetalle {
    const detalle = new DocumentoDetalle();
    const monto = parseFloat(this.formularioCorteCaja.get('totalEfectivo').value);

    detalle.DOCUMENT_DETAIL_TYPE = null; // Buscar el Id del registro 'Corte - Total Efectivo'
    detalle.QUANTITY = monto;
    detalle.TOTAL = monto;
    detalle.COMMENTS = 'Total Efectivo';
    return detalle;
  }

  generarDetalleVoucher(): DocumentoDetalle {
    const detalle = new DocumentoDetalle();
    const monto = parseFloat(this.formularioCorteCaja.get('totalVoucher').value);

    detalle.DOCUMENT_DETAIL_TYPE = null; // Buscar el Id del registro 'Corte - Total Vocuher'
    detalle.QUANTITY = monto;
    detalle.TOTAL = monto;
    detalle.COMMENTS = 'Total Voucher';
    return detalle;
  }

  generarDetalleIngresos(): DocumentoDetalle {
    const detalle = new DocumentoDetalle();
    const monto = parseFloat(this.formularioCorteCaja.get('totalIngresos').value);

    detalle.DOCUMENT_DETAIL_TYPE = null; // Buscar el Id del registro 'Corte - Total Ingresos'
    detalle.QUANTITY = monto;
    detalle.TOTAL = monto;
    detalle.COMMENTS = 'Total Ingresos';
    return detalle;
  }

  generarDetalleFondoCaja(): DocumentoDetalle {
    const detalle = new DocumentoDetalle();
    const monto = parseFloat(this.formularioCorteCaja.get('fondoCaja').value);

    detalle.DOCUMENT_DETAIL_TYPE = null; // Buscar el Id del registro 'Corte - Fondo'
    detalle.QUANTITY = monto;
    detalle.TOTAL = monto;
    detalle.COMMENTS = 'Fondo';
    return detalle;
  }

  generarDetalleDiferencia(): DocumentoDetalle {
    const detalle = new DocumentoDetalle();
    const monto = parseFloat(this.formularioCorteCaja.get('diferencia').value);

    detalle.DOCUMENT_DETAIL_TYPE = null; // Buscar el Id del registro 'Corte - Diferencia'
    detalle.QUANTITY = monto;
    detalle.TOTAL = monto;
    detalle.COMMENTS = 'Diferencia';
    return detalle;
  }

  generarCorteDetalle(): Documento {
    const usuarioSession: Usuario = JSON.parse(sessionStorage.getItem('user'));

    const corteDetalle = new Documento();
    corteDetalle.DOCUMENT_TYPE_ID = this.formularioCorteCaja.get('tipoCorte').value;
    corteDetalle.DOCUMENT_DATE = this.formularioCorteCaja.get('fechaCorte').value;
    corteDetalle.DELIVERY_COMMITMENT_DATE = this.formularioCorteCaja.get('fechaCorte').value;

    const accionDiferencia = this.formularioCorteCaja.get('accion').value;
    corteDetalle.COMMENTS = accionDiferencia ? accionDiferencia : null;

    corteDetalle.COMPANY_ID = usuarioSession.COMPANY_ID;
    corteDetalle.ORGANIZATION_ID = usuarioSession.ORGANIZATION_ID;
    corteDetalle.CREATED_BY = usuarioSession.USER_ID;
    corteDetalle.SUBTOTAL = this.formularioCorteCaja.get('totalIngresos').value;
    corteDetalle.IVA = 0;
    corteDetalle.TOTAL = this.formularioCorteCaja.get('totalIngresos').value;
    corteDetalle.PERCENTAGE_DISCOUNT = 0;

    corteDetalle.DOCUMENT_ID = this.idHistorialCorte;

    return corteDetalle;
  }

  marcarCamposRequeridos() {
    for (const control in this.formularioCorteCaja.controls) {
      this.formularioCorteCaja.get(control).markAsTouched();
    }
  }

  cargarPrimeraSeccion(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.restablecerSeccionIngresos();
      this.restablecerSeccionDetalleCorte();

      const formasPago = this.consultarFormasPago();
      const montoRetiro = this.consultarMontoRetiro();

      this.datosGeneralesSAE.showSpinnerLoading = true;
      forkJoin(formasPago, montoRetiro)
        .subscribe(async () => {
          if (this.idHistorialCorte) {
            this.consultarDetalleHistorico();
          } else {
            const montoCorteCaja = await this.consultarMontosCorteCaja();
          }
          this.datosGeneralesSAE.showSpinnerLoading = false;
          resolve();
        }, (error) => {
          this.datosGeneralesSAE.showSpinnerLoading = false;
          resolve();
        });

    });
  }

  restablecerSeccionIngresos() {
    const controles = ['cantidadDenominacion500',
      'cantidadDenominacion200',
      'cantidadDenominacion100',
      'cantidadDenominacion50',
      'cantidadDenominacion20',
      'cantidadDenominacion10',
      'cantidadDenominacion5',
      'cantidadDenominacion2',
      'cantidadDenominacion1',
      'totalEfectivo',
      'totalVoucher',
      'totalIngresos'];

    for (let index = 0; index < controles.length; index++) {
      const control = controles[index];
      this.formularioCorteCaja.get(control).setValue(0.00);
    }
  }

  restablecerSeccionDetalleCorte() {
    this.formularioCorteCaja.get('fondoCaja').setValue(this.fondoCaja);
    this.formularioCorteCaja.get('diferencia').setValue(0.00);
    this.formularioCorteCaja.get('faltante').setValue(0.00);
    this.formularioCorteCaja.get('accion').setValue(null);
    this.formularioCorteCaja.get('accion').disable();
  }

  consultarMontosCorteCaja(): Promise<void> {
    return new Promise((resolve, reject) => {
      const fechaCorte = this.formularioCorteCaja.controls['fechaCorte'].value;
      const usuarioSession: Usuario = JSON.parse(sessionStorage.getItem('user'));
      const idOrganizacion = usuarioSession.ORGANIZATION_ID;
      const body = { idOrganizacion, fechaCorte };

      this._generalService.metodoCallParams(body, this.corteCajaService + 'consultarMontosCorteCaja')
        .subscribe((montosCorteCaja: MontoCajaCorte[]) => {
          setTimeout(() => {
            this.metodosPago.forEach((metodoPago) => {
              const montoCorteCaja = montosCorteCaja.filter((monto) => monto.WAY_TO_PAY_ID === metodoPago.WAY_TO_PAY_ID)[0];
              if (montoCorteCaja) {
                this.formularioCorteCaja.controls[metodoPago.NAME].setValue(montoCorteCaja.TOTAL_MONTO ? parseFloat(montoCorteCaja.TOTAL_MONTO.toFixed(2)) : 0);
              } else {
                this.formularioCorteCaja.controls[metodoPago.NAME].setValue(0);
              }
              // Calcular el faltante

              const sumatoriaMontosMetodosPago = this.obtenerSumatoriaMontosMetodosPago();
              const montoRetiros = this.formularioCorteCaja.get('montoRetiro').value;
              const montoTotalIngresos = this.formularioCorteCaja.get('totalIngresos').value;
              const montoFondoCaja = this.formularioCorteCaja.get('fondoCaja').value;

              const diferencia = sumatoriaMontosMetodosPago - montoRetiros - (montoTotalIngresos - montoFondoCaja);
              if (diferencia > 0) {
                this.formularioCorteCaja.get('accion').enable();
              } else {
                this.formularioCorteCaja.get('accion').disable();
                this.formularioCorteCaja.get('accion').setValue(null);
              }
              this.formularioCorteCaja.get('faltante').setValue(Math.abs(diferencia).toFixed(2));
              this.formularioCorteCaja.get('diferencia').setValue(Math.abs(diferencia).toFixed(2));

            });
          }, 500);


          resolve();
        }, (error) => {
          console.log(error);
          reject();
        });
    });
  }

  consultarMontoRetiro(): Promise<void> {
    return new Promise((resolve, reject) => {
      const fechaCorte: Date = this.formularioCorteCaja.controls['fechaCorte'].value;
      const usuarioSession: Usuario = JSON.parse(sessionStorage.getItem('user'));
      const idOrganizacion = usuarioSession.ORGANIZATION_ID;
      const body = { idOrganizacion, fechaCorte };

      this._generalService.metodoCallParams(body, this.corteCajaService + 'consultarMontoRetiro')
        .subscribe((montosRetiro: MontoRetiro[]) => {
          const montoRetiro = montosRetiro[0];
          this.formularioCorteCaja.controls['montoRetiro'].setValue(montoRetiro.TOTAL_MONTO_RETIRO ? montoRetiro.TOTAL_MONTO_RETIRO : 0);
          resolve();
        }, (error) => {
          console.log(error);
          reject();
        });
    });
  }

  cargarTerceraSeccion(): Promise<void> {
    return new Promise((resolve, reject) => {
      const tiposCorte = this.consultarTiposCorte();
      const fondoCaja = this.consultarFondoCorteCaja();

      forkJoin(tiposCorte, fondoCaja)
        .subscribe(() => {
          resolve();
        });
    });
  }

  consultarTiposCorte(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._generalService.metodoCall(this.corteCajaService + 'consultarTiposCorte')
        .subscribe((tiposCorte: DocumentType[]) => {
          this.tiposCorte = tiposCorte;
          if (this.tiposCorte) {
            this.formularioCorteCaja.get('tipoCorte').setValue(this.tiposCorte[0].DOCUMENT_TYPE_ID);
          }
          resolve();
        }, (error) => {
          console.log(error);
          resolve();
        });
    });
  }

  consultarFondoCorteCaja(): Promise<void> {
    return new Promise((resolve, reject) => {

      if (this.idHistorialCorte) {
        resolve();
      } else {
        const usuarioSession: Usuario = JSON.parse(sessionStorage.getItem('user'));
        const idOrganizacion = usuarioSession.ORGANIZATION_ID;

        this._generalService.metodoCallParams(idOrganizacion, this.corteCajaService + 'consultarFondoCorteCaja')
          .subscribe((fondoCorteCaja: FondoCorteCaja[]) => {
            if (fondoCorteCaja.length > 0) {
              const fondoCaja = fondoCorteCaja[0];
              this.fondoCaja = fondoCaja.FONDO_CAJA ? parseFloat(fondoCaja.FONDO_CAJA) : 0;
            } else {
              this.fondoCaja = 0;
            }
            this.formularioCorteCaja.get('fondoCaja').setValue(this.fondoCaja);
            resolve();
          }, (error) => {
            console.log(error);
            resolve();
          });
      }

    });
  }

  imprimirTicket(element: HTMLElement) {
    const hiddenNodes: HTMLElement[] =
      Array.prototype.slice.call(element.querySelectorAll('.no-print'));

    // Ocultar antes de capturar
    hiddenNodes.forEach((el: any) => {
      // guarda el display previo por si no era '' (flex, inline, etc.)
      (el as any).dataset.prevDisplay = el.style.display || '';
      el.style.display = 'none';
    });

    this.datosGeneralesSAE.showSpinnerLoading = true;

    const originalBg = element.style.backgroundColor;
    element.style.backgroundColor = '#ffffff';

    (html2canvas as any)(element, {
      scale: 2,
      useCORS: true,
      backgroundColor: '#ffffff',
      windowWidth: element.scrollWidth
    })
      .then((canvas: HTMLCanvasElement) => {
        element.style.backgroundColor = originalBg;

        const pdf = new (jsPDF as any)({ orientation: 'p', unit: 'pt', format: 'a4' });
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const margin = 20;
        const usableWidth = pageWidth - margin * 2;

        const imgWidth = usableWidth;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        if (imgHeight <= (pageHeight - margin * 2)) {
          const imgData = canvas.toDataURL('image/png');
          pdf.addImage(imgData, 'PNG', margin, margin, imgWidth, imgHeight);
        } else {
          const pageCanvas = document.createElement('canvas');
          const pageCtx = pageCanvas.getContext('2d') as CanvasRenderingContext2D;
          const sliceHeightPx = Math.floor((canvas.width * (pageHeight - margin * 2)) / usableWidth);

          let currentY = 0;
          let first = true;

          while (currentY < canvas.height) {
            const remainingPx = canvas.height - currentY;
            const thisSlicePx = Math.min(sliceHeightPx, remainingPx);

            pageCanvas.width = canvas.width;
            pageCanvas.height = thisSlicePx;

            pageCtx.clearRect(0, 0, pageCanvas.width, pageCanvas.height);
            pageCtx.drawImage(canvas, 0, currentY, canvas.width, thisSlicePx, 0, 0, pageCanvas.width, pageCanvas.height);

            const sliceImgData = pageCanvas.toDataURL('image/png');
            const sliceHeightPt = (thisSlicePx * imgWidth) / canvas.width;

            if (!first) pdf.addPage();
            pdf.addImage(sliceImgData, 'PNG', margin, margin, imgWidth, sliceHeightPt);

            first = false;
            currentY += thisSlicePx;
          }
        }

        const d = new Date();
        const yyyy = d.getFullYear();
        const mm = ('0' + (d.getMonth() + 1)).slice(-2);
        const dd = ('0' + d.getDate()).slice(-2);
        pdf.save(`Corte_Caja_${yyyy}-${mm}-${dd}.pdf`);
      })
      .catch((err: any) => {
        console.error('Error al generar PDF:', err);
        this._generalService.toastCall('Ocurrió un error al generar el PDF.');
      })
      .then(() => {
        // ✅ restaurar SOLO al final (éxito o error)
        hiddenNodes.forEach((el: any) => {
          el.style.display = (el as any).dataset.prevDisplay || '';
          delete (el as any).dataset.prevDisplay;
        });
        this.datosGeneralesSAE.showSpinnerLoading = false;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/corte-caja/realizar-corte-caja/realizar-corte-caja.component.ts